import { on } from '@ember/modifier';

import ImagePicker from './image-picker.gts';
import { ImagePickerModal } from './image-picker/image-picker-modal.gts';

export default class ImagePickerBig extends ImagePicker {
  <template>
    <div
      class="image-editor position-relative form-control p-2
        {{if @readonly 'bg-body-secondary'}}"
      ...attributes
    >
      {{#if @value}}
        {{#let (this.mediaImageInfo) as |mediaInfo|}}
          <div class="d-flex flex-row flex-nowrap flex-shrink-0">
            <div class="position-relative">
              <img
                src={{if mediaInfo.record mediaInfo.record.thumbnailUrl @value}}
                alt="Preview"
                class="border border-dark shadow shadow-sm"
                width="200"
              />

              {{#unless @readonly}}
                <ImagePickerModal
                  @onSelectImage={{this.imageSelected}}
                  @requiredSize={{@sizeHint}}
                  @customSize={{@customSize}}
                >
                  <:input as |showModal|>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary position-absolute top-50 start-50 translate-middle border-white border-2 text-nowrap"
                      {{on "click" showModal}}
                    >
                      Change Image
                    </button>
                  </:input>
                </ImagePickerModal>
              {{/unless}}
            </div>
            <div class="flex-grow-1 p-3">
              {{#if mediaInfo.record}}
                <h5>{{mediaInfo.record.title}}</h5>
                <p>{{mediaInfo.record.alt}}</p>
              {{else}}
                <h5>Image</h5>
                <p>This image is not from the media library.</p>
              {{/if}}
            </div>
          </div>
        {{/let}}
      {{else}}
        {{#if @readonly}}
          <h5>Blank</h5>
          <p>No image has been selected.</p>
        {{else}}
          <h5>Please select an image</h5>
          <ImagePickerModal
            @onSelectImage={{this.imageSelected}}
            @requiredSize={{@sizeHint}}
            @customSize={{@customSize}}
          >
            <:input as |showModal|>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                {{on "click" showModal}}
              >Select Image</button>
            </:input>
          </ImagePickerModal>
        {{/if}}
      {{/if}}
    </div>
  </template>
}
